import FuseUtils from '@fuse/utils';
import moment from 'moment';
import { buildServicoFiscalInitialValue } from '../VendaProdutoServico/cadastro/servicoFiscalVendaUtils';

export const useIdentificadorInitialValue = (identificador) => {
  return identificador && `${identificador}`.padStart(3, '0');
};

export const useDataInitialValue = (data) => {
  return data || moment(new Date());
};

export const useClienteInitialValue = (cliente) => {
  return {
    id: cliente?.id || '',
    nome: cliente?.pessoa?.nome || '',
    tipoPessoa: cliente?.pessoa?.tipoPessoa || '',
  };
};

export const useFornecedorInitialValue = (fornecedor) => {
  return {
    id: fornecedor?.id || '',
    nome: fornecedor || '',
  };
};

export const useVendaInitialValue = (venda) => {
  return {
    id: venda?.id || '',
    identificador: venda?.identificador,
    nomeCliente: venda?.cliente?.pessoa?.nome || '',
  };
};

export const useCompraInitialValue = (compra) => {
  return {
    id: compra?.id || '',
    identificador: compra?.identificador,
    nomeCliente: compra?.cliente?.pessoa?.nome || '',
  };
};

/* export const useSituacaoInitialValue = (situacao) => {
  return situacao || 'EM_ORCAMENTO';
}; */

export const useProdutosServicosInitialValue = (produtosServicos) => {
  return produtosServicos?.length
    ? produtosServicos.map((produtoServico) => {
        const servicoFiscal = buildServicoFiscalInitialValueFromProduto(produtoServico);

        return {
          ...produtoServico,
          key: produtoServico.id,
          servicoFiscal,
          produtoServico: {
            valor: produtoServico.produto?.valorUnitario || produtoServico.servico?.valorVenda,
            produtoId: produtoServico.produto?.id,
            servicoId: produtoServico.servico?.id,
            codigo: produtoServico.servico?.codigo || produtoServico.produto?.codigo,
            nome: produtoServico.produto?.nome || produtoServico.servico?.descricao,
            descricaoDetalhada:
              produtoServico.produto?.descricaoDetalhada || produtoServico.servico?.descricaoDetalhada,
            promocaoVigenciaInicio:
              produtoServico.produto?.promocao?.vigenciaInicio || produtoServico.servico?.promocao?.vigenciaInicio,
            promocaoVigenciaFim:
              produtoServico.produto?.promocao?.vigenciaFim || produtoServico.servico?.promocao?.vigenciaFim,
            promocaoValor: produtoServico.produto?.promocao?.desconto || produtoServico.servico?.promocao?.valor,
            promocaoTipo: produtoServico.produto?.promocao?.tipoDesconto || produtoServico.servico?.promocao?.tipo,
            fiscal: produtoServico.produto?.fiscal || null,
            servicoFiscal,
          },
        };
      })
    : [{ key: FuseUtils.generateGUID() }];
};

const buildServicoFiscalInitialValueFromProduto = (produtoServico) =>
  buildServicoFiscalInitialValue(produtoServico.servico?.fiscal || {}, produtoServico.servicoFiscal);

export const useVendedorInitialValue = (vendedor) => {
  return {
    id: vendedor?.id || '',
    nome: vendedor?.pessoa?.nome || '',
  };
};

export const usePagamentoInitialValue = (pagamento) => {
  return {
    tipoPagamento: pagamento?.tipoPagamento || 'A_VISTA',
    formaRecebimento: pagamento?.formaRecebimento || 'BOLETO',
    avista: {
      dataVencimento: pagamento?.avista?.dataVencimento
        ? moment(pagamento.avista.dataVencimento)
        : moment(new Date()).add(7, 'd'),
      tipoPagamento: pagamento?.tipoPagamento || 'A_VISTA',
    },
    parcelamento: {
      tipoPagamento: pagamento?.tipoPagamento || 'A_VISTA',
      parcelas: pagamento?.parcelamento?.parcelas?.length
        ? pagamento.parcelamento?.parcelas.map(({ id, receitaId, dataVencimento, valor }) => ({
            id,
            receitaId,
            dataVencimento: dataVencimento ? moment(dataVencimento) : null,
            valorParcela: valor,
          }))
        : [],
      quantidade: pagamento?.parcelamento?.parcelas?.length,
    },
  };
};

export const useHabilitarFreteInitialValue = (produtosServicos) => {
  let habilitarFrete = false;

  // RNE-387
  for (let i = 0; i < produtosServicos?.length || 0; ++i) {
    const produtoServico = produtosServicos[i];
    if (produtoServico?.produto?.id) {
      habilitarFrete = true;
      break;
    }
  }

  return habilitarFrete;
};

export const useHabilitarTipoDescontoInitialValue = (produtosServicos) => {
  // RNE-388
  let habilitarTipoDesconto = false;

  for (let i = 0; i < produtosServicos?.length || 0; ++i) {
    const produtoServico = produtosServicos[i];
    if (produtoServico?.quantidade && produtoServico?.valor) {
      habilitarTipoDesconto = true;
      break;
    }
  }

  return habilitarTipoDesconto;
};

export const useHabilitarDescontoInitialValue = (tipoDesconto) => {
  // RNE-388
  return !!tipoDesconto;
};

export const useDisableFaturarVendaContrato = (statusFaturamentoUnificado) => {
  if (
    statusFaturamentoUnificado &&
    statusFaturamentoUnificado !== 'FATURAMENTO_PENDENTE' &&
    statusFaturamentoUnificado !== 'A_FATURAR'
  ) {
    return true;
  }
  return false;
};

export const useDisableUnificarCobrancaContratoVenda = (situacaoCobrancaUnificada) => {
  if (
    situacaoCobrancaUnificada &&
    situacaoCobrancaUnificada !== 'PENDENTE' &&
    situacaoCobrancaUnificada !== 'ACEITA' &&
    situacaoCobrancaUnificada !== 'NAO_GERADA' &&
    situacaoCobrancaUnificada !== 'NAO_TRATADA_BANCO'
  ) {
    return true;
  }
  return false;
};
